import ISurveyRequestResponse from '../interfaces/ISurveyRequestResponse';
import { Metadata } from './Metadata';
import Survey from './Survey';
import SurveyAnswer from './SurveyAnswer';

class SurveyRequestResponse implements ISurveyRequestResponse {
  answers: SurveyAnswer[];

  sessionKey: string;

  specification: Survey;

  metadata: Metadata;

  constructor(answers: SurveyAnswer[], surveyKey: string, specification: Survey, metadata: Metadata) {
    this.answers = answers;
    this.sessionKey = surveyKey;
    this.specification = specification;
    this.metadata = metadata;
  }

  public static parse(object: any) {
    return new SurveyRequestResponse(
      SurveyAnswer.fromJsonList(object.answers),
      object.sessionKey,
      Survey.fromJson(object.specification),
      object.metaData
    );
  }
}

export default SurveyRequestResponse;
